module.exports = "<div id=\"healtCheck\" class=\"healtCheck-section\">\r\n  {{statusObject}}\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/health-check/health-check.component.html
// module id = ./src/app/health-check/health-check.component.html
// module chunks = main